import React from "react";
import { motion } from "motion/react";

/**
 * Seamless infinite marquee.
 * items: array of strings.
 * accentEvery: every Nth item is highlighted in gold.
 */
const Marquee = ({ items = [], duration = 40, accent = "· ", className = "" }) => {
  const doubled = [...items, ...items, ...items];
  return (
    <div
      className={`relative overflow-hidden select-none ${className}`}
      data-testid="marquee"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-33.333%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity }}
      >
        {doubled.map((item, i) => (
          <span
            key={i}
            className="mx-8 flex items-center gap-8 font-display uppercase text-4xl md:text-6xl lg:text-8xl tracking-wide"
          >
            <span className={i % 2 === 0 ? "text-ink" : "text-gold"}>{item}</span>
            <span className="text-gold">{accent}</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default Marquee;
